import { API_URL } from "../constants";
import axios from "axios";
import middleware from "../util/middleware";
import { getSegmento } from "../util/generics.js";

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
        'x-segmento': getSegmento()
    }
});

/**
 * Clase para ver el request de artículos auxiliares
 */
class ArticulosPTRequest {

    static ListarArticulosPT(filtros) {
        return middleware.hasAuth(() => request.get(`articulospt`, {
            params: {
                externo: filtros?.externo,
                plaza_id: filtros?.plaza_id?.toString(),
                sucursal_id: filtros?.sucursal_id?.toString(),
                region_id: filtros?.region_id?.toString(),
                drive_id: filtros?.drive_id?.toString(),
                busqueda: filtros?.filtro ?? undefined,
                page: filtros?.page
            }
        }));
    }
    static ListarArticulosInventarioSinPaginacion(busqueda) {
        return middleware.hasAuth(() => request.get(`articulospt_no_paginaton`, {
            params: {
                busqueda: busqueda ?? undefined
            }
        }));
    }

    /**
     * Llamada el endpoint de django para crear / editar estatus de un producto
     * @param: data. objeto con información del producto
     * @return: Mensaje de éxito o error.
     */
     static EditarArticulosPT(data) {
        // const date = '"cuenta": {"ACTINDX": 1,"ACTNUMBR_1": "1000","ACTNUMBR_2": "000","ACTNUMBR_3": "000","ACTNUMBR_4": "000","ACTNUMBR_5": "000","ACTNUMBR_6": "000","ACTNUMBR_7": "000","ACTNUMBR_8": "0000","ACTNUMBR_9": "","ACTNUMBR_10": "","ACTNUMST": "1001-000-000-000-000-000-000-0000","DEX_ROW_ID": 1,"cuenta_contable": "1001-000-000-000-000-000-000-0000"}'
        return middleware.hasAuth(() => request.post(`articulosEdit`, data));
    }

}

export default ArticulosPTRequest;